import { PublicMarketingIndexPage } from "@/pages/public/marketing/marketing-index";

export function TradeshowsIndexPage() {
  return (
    <PublicMarketingIndexPage
      category="TRADESHOWS"
      title="Events"
      description="Where to find the DealerDog team. Upcoming events first, then past."
      pathBase="/tradeshows"
    />
  );
}

